import SliderTabBar from './slider-tab-bar';
export default SliderTabBar;